/**
 * @module Spinner
 */

import Component from '../Component';
import '../../../images/sprite/minus.svg';
import '../../../images/sprite/plus.svg';
import './styles.css';

/**
 * Счётчик.
 */
export default class Spinner extends Component {
    static className = 'spinner';

    initElements() {
        this.elements = {
            $dec: $('.spinner__btn--dec', this.$block),
            $inc: $('.spinner__btn--inc', this.$block),
            $input: $('.spinner__input', this.$block),
        };
    }

    setTemplateProperties() {
        /**
         * Начальное значение.
         * @type {number}
         */
        this.value = Number(this.elements.$input.attr('value')) || Number(this.elements.$input.prop('value')) || 0;

        /**
         * Величина шага.
         * @type {number}
         */
        this.step = Number(this.elements.$input.attr('step')) || 1;

        /**
         * Минимальное значение.
         * @type {number}
         */
        this.min = Number(this.elements.$input.attr('min')) || 0;

        /**
         * Максимальное значение.
         * @type {number}
         */
        this.max = Number(this.elements.$input.attr('max')) || 999;
    }

    init(options, pluginOptions) {
        super.init(options, pluginOptions);
        this.updateButtons();
    }

    /**
     * Обновляет состояние блокировки кнопок.
     */
    updateButtons() {
        this.elements.$dec.prop('disabled', false);
        this.elements.$inc.prop('disabled', false);

        if (this.value < this.min + this.step) {
            this.elements.$dec.prop('disabled', true);
        }

        if (this.value > this.max - this.step) {
            this.elements.$inc.prop('disabled', true);
        }
    }

    /**
     * Обновляет значение счётчика.
     *
     * @param {number} value Новое значение.
     */
    changeValue(value) {
        this.value = value;
        this.$block.attr('data-value', value);
        this.elements.$input.attr('value', value);
        this.elements.$input.val(value).trigger('change');

        // Хак для вуя
        this.elements.$input[0].dispatchEvent(new CustomEvent('change'));
    }

    /**
     * Меняет значение минимума.
     *
     * @param  {number} value Новое значение.
     */
    changeMin(value) {
        this.min = value;
        this.$block.attr('data-min', value);
    }

    /**
     * Меняет значение максимума.
     *
     * @param  {number} value Новое значение.
     */
    changeMax(value) {
        this.max = value;
        this.$block.attr('data-max', value);
    }
}

$(document).on('click', '.spinner__btn--dec', handleDecClick);
$(document).on('click', '.spinner__btn--inc', handleIncClick);
$(document).on('input', '.spinner__input', handleInput);
$(document).on('click', '.spinner__input', handleInputClick);

function handleDecClick(e) {
    const { currentTarget } = e;
    const $target = $(currentTarget);
    const $block = $target.closest('.spinner');
    const spinner = Spinner.getInstance($block);
    const value = spinner.value - spinner.step;

    spinner.changeValue(value);

    spinner.updateButtons();
}

function handleIncClick(e) {
    const { currentTarget } = e;
    const $target = $(currentTarget);
    const $block = $target.closest('.spinner');
    const spinner = Spinner.getInstance($block);
    const value = spinner.value + spinner.step;

    spinner.changeValue(value);

    spinner.updateButtons();
}

function handleInput(e) {
    const { currentTarget } = e;
    const $target = $(currentTarget);
    const $block = $target.closest('.spinner');
    const spinner = Spinner.getInstance($block);
    const { $input } = spinner.elements;

    let value = +$input.val();

    if (!$input.val().length || value < spinner.min || value > spinner.max) {
        ({ value } = spinner);
    }

    spinner.changeValue(value);

    spinner.updateButtons();
}

function handleInputClick(e) {
    e.currentTarget.select();
}
